// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import img0 from '../../assets/swiper0.png';
import img1 from '../../assets/swiper1.png';
import img2 from '../../assets/swiper2.png';
import locate from '../../assets/locate.png';
import phone from '../../assets/phone.png';
import { Typography, Grid, Box, Stack, Rating, Container } from "@mui/material"
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { addRecord } from '../../store/features/my';



export default function App() {

  const theme = useTheme();
  const navigate = useNavigate();
  const storageURL = process.env.REACT_APP_Stroage_URL;
  const { currentLineDetail } = useSelector(store => (store.line));



  const dispatch = useDispatch();
  useEffect(() => {
    // viewed
    // dispatch(addRecord(currentLineDetail.id))
    if(!currentLineDetail)
    {
      navigate('/home')
    }
  }, []);

  let lng = '';
  let lat = '';

  return (
    <Container sx={{ padding: 0 }}>
      {currentLineDetail&&<Box marginTop={0}>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50}
          slidesPerView={1}
          // pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          // onSlideChange={() => console.log('slide change')}
        >
          {/** Slides */}
          {[storageURL + currentLineDetail.nav_img].map((item, i) => (
            <SwiperSlide key={i}>
              <Typography
                variant={'h6'}
                align={'center'}
              >
                <img style={{ objectFit: 'cover', width: '100%', height: "250px" }} src={item}></img>
              </Typography>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>}

      {currentLineDetail&&<Container sx={{ position: 'relative', zIndex: 9, padding: '20px', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', marginTop: '-1.5rem', backgroundColor: '#fff' }}>
        <Grid container style={{ marginTop: "10px" }} spacing={0} direction="column">
          <Grid item container justifyContent="space-between" spacing={2}>
            <Grid container direction="column" item xs={12}>
              <Grid item sx={{ fontWeight: "bold" }}>{currentLineDetail.name}</Grid>
              <Grid item>
                {/* <Stack spacing={1} direction="row">
                  <Rating size="small" name="half-rating-read" defaultValue={5 * currentLineDetail.score / 100} precision={0.5} readOnly />
                  <Typography sx={{ fontSize: 14 }} color="text.secondary">
                    2.5
                  </Typography>
                </Stack> */}
              </Grid>
            </Grid>
          </Grid>
          <Grid item container justifyContent="space-between" spacing={2}>
            <Grid container direction="column" item xs={8}>
              {/* <Grid item>xx区xx县</Grid> */}
              <Grid item sx={{ color: "#999" }}>{currentLineDetail.addr}</Grid>
            </Grid>
            <Grid item container xs={4} spacing={1} alignContent='center' alignItems='center'>
              
            </Grid>
          </Grid>
          <Grid sx={{ marginTop: "15px", paddingBottom: "40px" }}>
            <Typography component="div" dangerouslySetInnerHTML={{ __html: currentLineDetail.desc }} />
          </Grid>
        </Grid>

      </Container >}
    </Container >
  );
}